export const checkPlatNomor = (date) => {
  if (!date) {
    return null;
  }
  const getDate = new Date(date).getDate();

  return getDate % 2 === 0 ? "genap" : "ganjil";
};
